import { render } from "./tagManage BackUp.vue?vue&type=template&id=9f1cd73c"
import script from "./tagManage BackUp.vue?vue&type=script&lang=js"
export * from "./tagManage BackUp.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/active/tagManage BackUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f1cd73c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f1cd73c', __exports__)) {
    console.log('reload')
    api.reload('9f1cd73c', __exports__)
  }
  
  module.hot.accept("./tagManage BackUp.vue?vue&type=template&id=9f1cd73c", () => {
    console.log('re-render')
    api.rerender('9f1cd73c', render)
  })

}


export default __exports__